<template>
    <Modal
        class="placements-modal-container"
        showHeaderSeparator
        :version="1"
        :showFooter="false"
        :showFooterSeparator="false"
        v-on="$listeners"
        v-bind="$props"
    >
        <div slot="modal-body">
            <Table :columns="columns"
                :rows="rows"
                :sortBy="sortBy"
                :sortDirection="sortDirection"
                :pagination="false"
                @sortChanged="handleSortChanged"
            >
                <template v-slot:row-cell="{ rowCell, columnIndex }">
                    <RewardColumn
                        v-if="columns[columnIndex].id === '1'"
                        readOnly
                        :placement="rowCell.data.placement"
                    />
                    <CappingPacingColumn
                        v-if="columns[columnIndex].id === '2'"
                        readOnly
                        :placement="rowCell.data.placement"
                    />
                    <div v-else>
                        <span :class="{'font-4': columnIndex === sortedIndex}" class="inactive">
                            {{ rowCell.text }}
                        </span>
                    </div>
                </template>
            </Table>
        </div>
    </Modal>
</template>

<script>
import Modal from 'components/modals/Modal.vue';
import Table from '@/components/table/Table.vue';
import CappingPacingColumn from '@/pages/monetize/segments/segmentForm/columns/CappingPacingColumn.vue';
import RewardColumn from '@/pages/monetize/segments/segmentForm/columns/RewardColumn.vue';
import { sortBy } from 'lodash';

export default {
    name: 'PlacementsModal',
    props: {
        ...Modal.props,
        placements: {
            type: Array,
            required: true
        },
        supportsReward: {
            type: Boolean,
            default: true
        }
    },
    components: {
        CappingPacingColumn, RewardColumn, Table, Modal
    },
    data() {
        return {
            sortBy: '',
            sortDirection: 'desc'
        };
    },
    computed: {
        columns() {
            return [
                { id: '0', text: 'Placement Name' },
                ...(this.supportsReward ? [{ id: '1', text: 'Reward', noSort: true }] : []),
                { id: '2', text: 'Capping & Pacing', noSort: true }
            ];
        },
        rows() {
            // sort by placement id initially
            const placements = sortBy(this.placements, 'id');

            return placements.map((placement, index) => {
                const data = { placement, exception: {} };
                return [
                    { id: `${index}0`, text: placement.name, value: placement.name },
                    ...(this.supportsReward ? [{ id: `${index}1`, data }] : []),
                    { id: `${index}2`, data }
                ];
            });
        },
        sortedIndex() {
            return this.columns.findIndex((col) => col.id === this.sortBy);
        }
    },
    methods: {
        handleSortChanged(sortId, sortDirection) {
            this.sortBy = sortId;
            this.sortDirection = sortDirection;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

.inactive {
    color: $light-800;
}

.placements-modal-container.v1 ::v-deep .modal-container {
    width: 730px;
}
</style>
